import { useCallback } from 'react';
import { PostHogEvent } from 'constants/posthog-events';
import { useCurrentAccountId } from 'customHooks/useCurrentAccountId';
import { useCurrentUser } from 'customHooks/useCurrentUser';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CaptureResult } from 'posthog-js';
import { usePostHog } from 'posthog-js/react';

const usePosthog = () => {
    const posthog = usePostHog();
    const flags = useFlags();

    const { id: userId } = useCurrentUser();
    const accountId = useCurrentAccountId();

    const pushEvent = useCallback(
        (eventName: PostHogEvent, properties: CaptureResult['properties'] = {}) => {
            posthog?.capture(eventName, {
                ...properties,
                user_id: userId,
                account_id: accountId,
                flags,
            });
        },
        [userId, accountId, posthog, flags],
    );

    return { pushEvent };
};

export { usePosthog };
